import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "cp-modal",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "cp-header" }
const _hoisted_3 = { class: "cp-body" }
const _hoisted_4 = {
  key: 0,
  class: "cp-mode-divider"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "cp-group" }
const _hoisted_7 = { class: "cp-group-label" }
const _hoisted_8 = { class: "cp-group-items" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "cp-item-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "cp-fade" }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cp-backdrop",
              onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "cp-title" }, [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none"
                    }, [
                      _createElementVNode("path", {
                        d: "M8 2v12M2 8h12",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round"
                      })
                    ]),
                    _createTextVNode(" Criar ")
                  ], -1)),
                  _createElementVNode("button", {
                    class: "cp-close",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                    "aria-label": "Fechar"
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("svg", {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 14 14",
                      fill: "none"
                    }, [
                      _createElementVNode("path", {
                        d: "M2 2l10 10M12 2L2 12",
                        stroke: "currentColor",
                        "stroke-width": "1.8",
                        "stroke-linecap": "round"
                      })
                    ], -1)
                  ]))])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedSections, (section) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: section.id
                    }, [
                      (section.modeLabel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("span", {
                              class: "cp-mode-icon",
                              innerHTML: section.modeIcon
                            }, null, 8, _hoisted_5),
                            _createTextVNode(" " + _toDisplayString(section.modeLabel), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(section.label), 1),
                        _createElementVNode("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: item.action + (item.payload || ''),
                              class: _normalizeClass(["cp-item", [`cp-item--${item.color || 'default'}`]]),
                              type: "button",
                              onClick: ($event: any) => (_ctx.doAction(item.action, item.payload))
                            }, [
                              _createElementVNode("span", {
                                class: "cp-item-icon",
                                innerHTML: item.icon
                              }, null, 8, _hoisted_10),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(item.label), 1)
                            ], 10, _hoisted_9))
                          }), 128))
                        ])
                      ])
                    ], 64))
                  }), 128))
                ])
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}